export default class BaseParametersFormattingStrategy {
    init(config) {
        this.parametersFormatter = this.createParametersFormatter(config);
        this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config)

        return this;
    }

    createParametersFormatter(config) {
        // abstract
    }

    createDateParametersFormattingStrategy(config) {
        // abstract
    }

    formatMainPartOfLightboxTitle(selectedParameters) {
        // abstract
    }

    formatParametersText(selectedParameters) {
        // abstract
    }

    formatSpecifyingPartOfLightboxTitle(selectedParameters) {
        return this.dateParametersFormattingStrategy.formatSpecifyingInformation(selectedParameters.dateParameters);
    }
}


// WEBPACK FOOTER //
// ./web/js/parametersFormatting/BaseParametersFormattingStrategy.js